// Grouped client for Google operations
import { ApiConfiguration } from '../ApiConfiguration';
import { GetAddressPredictionsResponse } from '../models/GetAddressPredictionsResponse';
import { GetGooglePlaceResponse } from '../models/GetGooglePlaceResponse';
import { UpdatePushNotificationRegistrationResponse } from '../models/UpdatePushNotificationRegistrationResponse';
import { GetAddressPredictionsResponseSerializer } from '../serializers/GetAddressPredictionsResponseSerializer';
import { GetGooglePlaceResponseSerializer } from '../serializers/GetGooglePlaceResponseSerializer';
import { UpdatePushNotificationRegistrationResponseSerializer } from '../serializers/UpdatePushNotificationRegistrationResponseSerializer';

/**
 * HTTP client for Google operations
 *
 * Client for Google operations
 */
export class GoogleClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  async getAddressPredictions(search?: string | null, center?: string | null, options?: { headers?: Record<string, string> }): Promise<GetAddressPredictionsResponse> {
    const path = '/google/api/AppPlaces/Autocomplete';

    const queryParams = new URLSearchParams();
    if (search !== undefined) {
      queryParams.append('search', String(search));
    }
    if (center !== undefined) {
      queryParams.append('center', String(center));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return GetAddressPredictionsResponseSerializer.fromObject(data);
  }

  async getGooglePlace(id: string, options?: { headers?: Record<string, string> }): Promise<GetGooglePlaceResponse> {
    let path = '/google/api/AppPlaces({id})'
      .replace('{id}', encodeURIComponent(String(id)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return GetGooglePlaceResponseSerializer.fromObject(data);
  }

  /**
   * Update Push Notification Registration
   * Update Push Notification Registration
   * @param options Optional request options (additional headers, etc.)
   */
  async updatePushNotificationRegistration(token: string, options?: { headers?: Record<string, string> }): Promise<UpdatePushNotificationRegistrationResponse> {
    const path = '/app/api/PushNotification';

    const queryParams = new URLSearchParams();
    if (token !== undefined) {
      queryParams.append('token', String(token));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PUT',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return UpdatePushNotificationRegistrationResponseSerializer.fromObject(data);
  }

}
